import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const updateLevelStructure = (resource, id, { structureId, ...values }) => {
  return axios.put(`/api/${resource}/${id}/setup/level_structures/${structureId}`, values);
};

export const useUpdateLevelStructure = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => updateLevelStructure(resource, id, values),
    onSuccess: () => {
      enqueueSnackbar('Level structure successfully updated', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
